// @flow
import React, { Fragment, type Node } from 'react';
import isImage from 'is-image';

import DynamicLink, {
  type Props as DynamicLinkProps,
} from 'Components/frameworks/dynamic-link/DynamicLink.jsx';
import Image from 'Components/frameworks/image/Image.jsx';
import { VideoWithFullScreen } from 'Components/frameworks/video-with-full-screen/VideoWithFullScreen.jsx';

import { cardMediaThemes } from './CardMedia.themes';

export type Media = {
  alt?: string,
  ratioKey?: string,
  thumbnail?: string,
  thumbnailLabel?: string,
  title?: string,
  url: string,
};

type Props = {
  children?: Node,
  closeLabel?: string,
  link?: ?DynamicLinkProps,
  media?: Media,
  theme?: string,
};

export function CardMedia(props: Props) {
  const { children, closeLabel, link = {}, media = {}, theme = 'default' } = props;
  const { thImage, thVideo, thImageRatio } = cardMediaThemes[theme];

  // eslint-disable-next-line clubmed/no-fake-component
  const withLink = node => {
    return node && link && link.url ? (
      <DynamicLink {...link} className="block">
        {node}
      </DynamicLink>
    ) : (
      node
    );
  };

  return (
    <Fragment>
      {isImage(media.url || '') ? (
        withLink(
          <div className="image-responsive-cell rounded-tiny overflow-hidden">
            <Image
              altMsg={media.alt}
              className={thImage}
              imageUrl={media.url}
              ratioKey={media.ratioKey || thImageRatio}
            />
          </div>,
        )
      ) : (
        <VideoWithFullScreen
          buttonLabel={media.thumbnailLabel}
          className={thVideo}
          closeLabel={closeLabel}
          thumbnail={media.thumbnail || ''}
          title={media.title}
          url={media.url}
        />
      )}
      {withLink(children)}
    </Fragment>
  );
}
